import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { LoyaltyCodesForProductView } from '@src/api';
import { BaseResizableComponent } from '@src/app/modules/base';

import { LoyaltyProgramReadService, LpMyProductCodesStoreService, ProductCodesStoreKeys } from '../services';

@Component({
  selector: 'lp-my-product-codes',
  templateUrl: './lp-my-product-codes.component.html',
  styleUrls: ['./lp-my-product-codes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LpMyProductCodesComponent extends BaseResizableComponent {
  private readonly loyaltyProgramReadService = inject(LoyaltyProgramReadService);
  private readonly lpMyProductCodesStore = inject(LpMyProductCodesStoreService);

  productCodes?: LoyaltyCodesForProductView[];

  loading = true;

  override ngOnInit(): void {
    super.ngOnInit();

    this.loyaltyProgramReadService.getMyProductCodes();

    this.lpMyProductCodesStore
      .getDataObservable(ProductCodesStoreKeys.All)
      .pipe(takeUntil(this.destroyed$$))
      .subscribe(items => {
        this.productCodes = items;
        this.loading = !items;

        this.cdr.markForCheck();
      });
  }
}
